<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <!--<Cascader  class="search-ipt" :data="regionList" change-on-select placeholder="请选择地区"></Cascader>-->
            <Input class="search-ipt" type="text" v-model="searchIpt.region" placeholder="请输入学校地址" @on-enter="getSchoolsList" clearable/>
            <Input class="search-ipt" type="text" v-model="searchIpt.keyword" placeholder="请输入学校名称或ID" @on-enter="getSchoolsList" clearable/>
            <Button type="primary" icon="md-search" class="search_tn" @click="getSchoolsList">搜索</Button>
          </div>
        </div>
      </div>
      <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="schoolsData">
        <template slot-scope="{ row,index }" slot="studentCount">
          <div class="jump_color" @click="toStudentList(row.name)">{{row.studentCount}}</div>
        </template>
        <template slot-scope="{ row, index }" slot="memberCount">
          <div class="jump_color" @click="toUserList(row.id)">{{row.memberCount}}</div>
        </template>
        <template slot-scope="{row,index}" slot="classCount">
          <div class="jump_color" @click="toClassesList(row.name)">{{row.classCount}}</div>
        </template>
      </Table>
    </div>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getSchoolsList"></paging>
  </div>
</template>
<script>
  import {_getSchoolsList} from '../api/api';
  import paging from '../templates/Paging.vue';
  export default {
    name:'Schools',
    components: {paging},
    data() {
      return {
        pageSize: 10, // 每页条数
        totalNum: 0, // 数据总条数
        searchIpt: {
          keyword: null,
          region: ''
        },
        tableHeader: [
          {
            title: 'ID',
            key: 'id'
          },
          {
            title: '所在地区',
            key: 'region'
          },
          {
            title: '学校名称',
            key: 'name'
          },
          {
            title: '学生人数',
            key: 'studentCount',
            slot: 'studentCount'
          },
          {
            title: '教职工人数',
            key: 'memberCount',
            slot: 'memberCount'
          },
          {
            title: '班级数',
            key: 'classCount',
            slot: 'classCount'
          }
        ],
        schoolsData: [],
        regionList: [
          {
            value: 'beijing',
            label: '北京',
            children: [
              {
                value: 'gugong',
                label: '故宫'
              },
              {
                value: 'tiantan',
                label: '天坛'
              },
              {
                value: 'wangfujing',
                label: '王府井'
              }
            ]
          },
          {
            value: 'jiangsu',
            label: '江苏',
            children: [
              {
                value: 'nanjing',
                label: '南京',
                children: [
                  {
                    value: 'fuzimiao',
                    label: '夫子庙',
                  }
                ]
              },
              {
                value: 'suzhou',
                label: '苏州',
                children: [
                  {
                    value: 'zhuozhengyuan',
                    label: '拙政园',
                  },
                  {
                    value: 'shizilin',
                    label: '狮子林',
                  }
                ]
              }
            ],
          }
        ]
      }
    },
    methods: {
//      获取学校列表
      getSchoolsList(msg){
        const self = this;
        let params = {
          address: self.searchIpt.region,
          id:/^\d*$/gi.test(self.searchIpt.keyword) ? self.searchIpt.keyword : '',
          name:/^\d*$/gi.test(self.searchIpt.keyword) ? '' : self.searchIpt.keyword,
          page: typeof(msg) === 'object' && msg.pageNum ? msg.pageNum - 1 : 0,
          size: self.pageSize
        };
        _getSchoolsList({params:params}).then(res => {
          if(res.code === 0) {
            self.schoolsData = res.data.content;
            self.totalNum = res.data.total;
          }
        })
      },
      // 跳转到学生列表
      toStudentList(schoolName) {
        this.$router.push(`/students?schoolName=${schoolName}`);
      },
      // 跳转到用户列表
      toUserList(id) {
        this.$router.push(`/user?sId=${id}`);
      },
//      跳转到班级列表
      toClassesList(schoolName) {
        this.$router.push(`/klasses?schoolName=${schoolName}`);
      }
    },
    created() {
      if(this.$route.query.id) {
        this.searchIpt.keyword = this.$route.query.id
      }
    },
    mounted() {
      this.getSchoolsList();
    }
  };
</script>
<style scoped>
  .search-ipt {
    width: 250px;
  }

  .jump_color {
    padding: 15px 0;
    color: #2d8cf0;
    font-size: 16px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Schools.vue